import styles from './BurgerMenuLoading.module.scss';

export const BurgerMenuLoading = () => {
  return <div className={styles['burger-menu-loading']} />;
};
